import React from 'react'
import './form.css';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useNavigate } from 'react-router-dom';
import Nav from '../Nav/Nav'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
   


const Form = () => {
    const navigate=useNavigate();
    async function  toastAdd(){
       toast.success('added')
       setTimeout(()=>{navigate('/filter')},3000);
    }

  return (
    <div>
        <Nav/>

        <div className="FormLeft">
            <div className="Title">List Your Property</div>

            <div className="FilterLeft1">
               <div className="FormTitle" id="FilterTitle" >Category</div>
                    <input type="checkbox" name="Apartment" id="apart"/>
                    <label htmlFor="apart">Apartment</label> <br/>
                    <input type="checkbox" name="Houses" id="Houses" />
                    <label htmlFor="Houses">Houses</label>   <br/>
                    <input type="checkbox" name="Rooms" id="Rooms" />
                    <label htmlFor="Rooms">Rooms</label>     <br/>
                    <input type="checkbox" name="Townhouses" id="Townhouses" />
                    <label htmlFor="Townhouses">Townhouses</label>
            </div>
            <div className="FilterLeft2">
                <span className='FormTitle'> Price Range </span>{" "} <br/> <br/>
                <input type="text" name="gate" id="apart"/>
                <br/><br/>
                <span style={{"marginLeft":"20%"}}>to</span>
                 <br/><br/>
                 <input type="text" name="gate" id="apart"/>
            </div>
            <div className="FilterLeft3">
              <div className="FormTitle">Rooms</div>
              <div className="FilterLeft3Content">
                <div className="Content1">
                  <div className="ContentTitle">Bedroom</div>
                  <select name="bed" id="bed" style={{"width":"50%"}}>
                    <option value='min1' default> 1</option>
                    <option value='min1'>1</option>
                    <option value='min1'>2</option>
                    <option value='min1'>3</option> 
                  </select> 
                </div>
                <div className="Content2">
                  <div className="ContentTitle">Bathrooms</div>
                  <select name="bed" id="bed" style={{"width":"50%"}}>
                    <option value='min1' default> 1</option>
                    <option value='min1'>1</option>
                    <option value='min1'>2</option>
                    <option value='min1'>3</option> 
                  </select>      
                </div>
            </div>
            </div><br/>

            <div className="FilterLeft4">
              <div className="FormTitle">Rental Period</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />1-12 months </span><br/>
                 <span><input type="radio" name="12m" id="" />12-24 months</span>  <br/>
                 <span><input type="radio" name="12m" id="" />24-36 months</span> <br/>
                 <span><input type="radio" name="12m" id="" />36+ months </span><br/>
              </div>
            </div>

            <div className="FilterLeft5">
               <div className="FormTitle" id="title" >Amenties</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Gated Community</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Lift</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Swimming Pool</label>     <br/>
                    <input type="checkbox" name="Gym" id="Gym" />
                    <label htmlFor="Gym">Gym</label>   <br/>
                    <input type="checkbox" name="Parking" id="Parking" />
                    <label htmlFor="Parking">Parking</label>   <br/>
                    <input type="checkbox" name="Gas" id="Gas" />
                    <label htmlFor="Gas">Gas Pipeline</label>   
            </div>


            <div className="FilterLeft10">
              <span className='FormTitle'>Sq Ft  </span>{" "} <br/> <br/>
                <span className='FilterLeft2SubTitle'> $3,200 - $206,0000 </span>{" "}
                <Box sx={{ width: 200 }} className='slider'>
                <Slider size='small' defaultValue={3200} aria-label="Default" min={3200} max={206000} valueLabelDisplay="auto" />
                </Box>
            </div>

            
            <div className="FilterLeft12">
            <div className="FormTitle" id="title" >Photos / Videos</div>
              <input type="file"  />
              <input type="file"  />
              <input type="file"  />
              <input type="file"  />
              <input type="file"  />
              <input type="file"  />
            </div>

            <div className="FilterLeft12">
            <div className="FormTitle" id="title" >Address </div>
              <textarea  style={{"width":"18vw","height":"10vh","border":"1px solid grey"}}></textarea>
            </div>

            <div className="FilterLeft6">
              <div className="FormTitle">Age</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />1 year </span><br/>
                 <span><input type="radio" name="12m" id="" />2-5 years</span>  <br/>
                 <span><input type="radio" name="12m" id="" />10-20 years</span> <br/>
                 <span><input type="radio" name="12m" id="" />{'> '}20 years </span><br/>
              </div>
            </div>

            <div className="FilterLeft8">
              <div className="FormTitle">Available</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />in 10 days</span><br/>
                 <span><input type="radio" name="12m" id="" />in 30 days</span>  <br/>
                 <span><input type="radio" name="12m" id="" />in 2-4 months</span> <br/>
                 <span><input type="radio" name="12m" id="" />{'> '} 4 months </span><br/>
              </div>
            </div>

            <div className="FilterLeft9">
               <div className="FormTitle" id="title" >Furnishing</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Fully furnished</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Semi furnished</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Not furnished</label> 
            </div>


            <div className="FilterLeft11">
               <div className="FormTitle" id="title" >Lease Type</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Family</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Single</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Bachelor</label>     <br/>
            </div>

            <div className="FilterLeft12">
               <div className="FormTitle" id="title" >City</div>
                    <input type="text" name="gate" id="apart"/>
            </div>

            <div className="FilterLeft13">
               <div className="FormTitle" id="title" >State</div>
                    <input type="text" name="gate" id="apart"/>
            </div>

            <div className="FilterLeft14">
               <div className="FormTitle" id="title" >Proof of Ownership</div>
                    <input type="file" name="gate" id="apart"/>
            </div>

            <div className="FilterLeft14">
               <div className="FormTitle" id="title" >Proof of Identity</div>
                    <input type="file" name="gate" id="apart"/>
            </div>

            <div className='SubmitFilter'>
              <button className="SubmitFormButton" onClick={toastAdd}>Add property</button>
            </div>
        </div>

        <ToastContainer/>

    </div>
  )
}

export default Form